// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Button from 'components/Button';
import Icon from 'components/Icon';
import StatusLabel from 'components/StatusLabel';
import type { Status } from 'components/StatusLabel';
import { colors, transition } from 'theme';

const CloseButton = styled(Button)`
  color: ${colors.battleshipGrey};
  transition: all ${transition};
  &:hover {
    color: ${colors.waterBlue};
  }
`;

const UserNotification = ({
  status,
  children,
  dismiss,
  ...props
}: {
  status?: Status,
  children: React.Node,
  dismiss?: Function
}) => (
  <Box position="relative" {...props}>
    {status && <StatusLabel status={status} />}

    <Box lineHeight={1.375}>{children}</Box>

    {dismiss && (
      <Box position="absolute" top={0} right={0}>
        <CloseButton onClick={dismiss}>
          <Icon name="close" width={12} height={12} fill="currentColor" />
        </CloseButton>
      </Box>
    )}
  </Box>
);

export default UserNotification;
